export default __webpack_public_path__ + "static/media/image-main-2-w@3x.dbd6db74.webp";